import React from "react";
import "./pagination.scss";
import leftIcon from "../../images/pagination/arrow-left.svg";
import rightIcon from "../../images/pagination/arrow-right.svg";
import ReactPaginate from "react-paginate";

const Pagination = ({ pageCount = 20, setCurrentPage = 1, fromValue, toValue, totalValue }) => {
    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <div className="pagination">
            <ReactPaginate
                nextLabel=">"
                previousLabel="<"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                pageClassName="pagination__selector-button pagination__selector-number"
                pageLinkClassName="pagination__selector-button pagination__selector-number"
                previousClassName="pagination__selector-button pagination__selector-number"
                previousLinkClassName="page-link"
                nextClassName="pagination__selector-button pagination__selector-number"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="pagination__selector-button pagination__selector-number"
                breakLinkClassName="page-link"
                containerClassName="pagination__selector"
                activeClassName="pagination__selector-button pagination__selector-number"
                activeLinkClassName="pagination__selector-active pagination__selector-button pagination__selector-number"
                renderOnZeroPageCount={true}
            />
            <div className="pagination__title">{`Показано с ${fromValue} по ${toValue} из ${totalValue} записей`}</div>
            {/* <div className="pagination__selector">
                <div className="pagination__selector-arrow-left pagination__selector-button">
                    <img src={leftIcon} alt="arrow" />
                </div>
                <div className="pagination__selector-number pagination__selector-active pagination__selector-button">
                    1
                </div>
                <div className="pagination__selector-number pagination__selector-button">2</div>
                <div className="pagination__selector-number pagination__selector-button">3</div>
                <div className="pagination__selector-more pagination__selector-button">...</div>
                <div className="pagination__selector-number pagination__selector-button">20</div>
                <div className="pagination__selector-arrow-right pagination__selector-button">
                    <img src={rightIcon} alt="arrow" />
                </div>
            </div>
            <div className="pagination__title">Показано с 1 по 10 из 23 записей</div> */}
        </div>
    );
};

export default Pagination;

// import ReactPaginate from "react-paginate";

// export function PaginatedItems({ pageCount, setCurrentPage }) {
//     const handlePageClick = (event) => {
//         setCurrentPage(event.selected + 1);
//     };

//     return (
//         <ReactPaginate
//             nextLabel=">"
//             previousLabel="<"
//             onPageChange={handlePageClick}
//             pageRangeDisplayed={3}
//             marginPagesDisplayed={2}
//             pageCount={pageCount}
//             pageClassName="page-item"
//             pageLinkClassName="page-link"
//             previousClassName="page-item"
//             previousLinkClassName="page-link"
//             nextClassName="page-item"
//             nextLinkClassName="page-link"
//             breakLabel="..."
//             breakClassName="page-item"
//             breakLinkClassName="page-link"
//             containerClassName="pagination"
//             activeClassName="active"
//             renderOnZeroPageCount={true}
//         />
//     );
// }
